module.exports = __webpack_public_path__ + "img/orange_109.7ccce138.png";